// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"417":"2a801114","752":"39778fa0"}[chunkId] + ".chunk.js";
};